import { SectionTitle } from '@/ui/index';
import SliderWrapper from '@/ui/SliderWrapper/SliderWrapper';

import styles from './SliderContainer.module.scss';

const SliderContainer = ({
  title = '',
  icon = '',
  linkText = '',
  link = '',
  addClass = '',
  options,
  children,
}) => {
  return (
    <div
      className={`section ${addClass || ''}`}
      itemScope
      itemType='https://schema.org/Section'
    >
      {title && (
        <div className={'wrapper'}>
          <SectionTitle
            icon={icon}
            buttonText={linkText}
            href={link}
            className={styles.title}
            titleModify='title--large'
          >
            {title}
          </SectionTitle>
        </div>
      )}
      {!!children && (
        <SliderWrapper options={options} arrows>
          {children}
        </SliderWrapper>
      )}
    </div>
  );
};

export default SliderContainer;
